export const getPersonsFrag = `
    id
    note
    validFrom
    user {
        id
        titleBeforeName
        name
        surname
        titleAfterName
        email
        groups {
            id
        }
    }
`;
